export default __webpack_public_path__ + "static/media/sortIcon.8b78ec44.svg";